import { render, staticRenderFns } from "./AddAlarmHandler.vue?vue&type=template&id=16114422"
import script from "./AddAlarmHandler.vue?vue&type=script&lang=js"
export * from "./AddAlarmHandler.vue?vue&type=script&lang=js"
import style0 from "./AddAlarmHandler.vue?vue&type=style&index=0&id=16114422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports